import { useState } from 'react'
import { useDialogs } from '@shared/hooks/dialogs'
import { useMethods } from '@shared/hooks/methods'
import { useQueryClient } from '@tanstack/react-query'

import axios from '@shared/utils/axios'

export const useItem = (item) => {
    const { showOnly } = useDialogs()
    const {
        ask,
        showMessage
    } = useMethods()
    const queryClient = useQueryClient()
    const [anchor, setAnchor] = useState(null)

    // methods
    const handleClick = async () => {
        if (item.is_draft) {
            handleEdit()
        } else {
            showOnly('previewEstimation', item)
        }
    }

    const handleEdit = async () => {
        setAnchor(null)
        showMessage({
            text: 'جارٍ التحميل...',
            loading: true
        })
        try {
            const request = await axios.get(`estimations/${item.id}/`)
            showMessage(null)
            showOnly('estimation', request.data)
        } catch {
            showMessage({ text: 'حدث خطأ' })
        }
    }

    const handleDelete = () => {
        setAnchor(null)
        ask(
            `هل تريد حذف المقايسة '${item.number}'`,
            async () => {
                showMessage({
                    text: 'جارٍ الحذف...',
                    loading: true
                })
                try {
                    await axios.delete(`estimations/${item.id}/`)
                    queryClient.invalidateQueries({ queryKey: ['estimations'] })
                    queryClient.invalidateQueries({ queryKey: ['quick-look'] })
                    queryClient.invalidateQueries({ queryKey: ['offices'] })
                    showMessage({ text: 'تم حذف' })
                } catch {
                    showMessage({ text: 'حدث خطأ' })
                }
            }
        )
    }

    const handleExport = async () => {
        setAnchor(null)
        showMessage({
            text: 'جارٍ التصدير',
            loading: true
        })
        try {
            const request = await axios.get(
                `estimations/${item.id}/export/`,
                {
                    responseType: 'blob',
                    params: { dep: ['documents', 'location', 'violations'] },
                    paramsSerializer: params => {
                        const search = new URLSearchParams()
                        params.dep.forEach(dep => {
                            search.append('dep', dep)
                        })
                        return search.toString()
                    }
                }
            )

            const url = window.URL.createObjectURL(request.data)
            const a = document.createElement('a')
            a.href = url
            a.download = `${item.number || 'مقايسة'}`
                .replace(/[<>:"/\\|?*\x00-\x1F]/g, '_')
                .replace(/\s+/g, ' ')
                .trim()
                .replace(/[. ]+$/, '')+'.pdf'
            a.click()
            URL.revokeObjectURL(url)

            showMessage(null)
        } catch (e) {
            if(e.status == '404') {
                showMessage({ text: 'لا توجد صور لهذه المقايسة' })
            } else {
                showMessage({ text: 'حدث خطأ' })
            }
        }
    }

    const handlePin = async () => {
        setAnchor(null)
        showMessage({
            text: 'جارٍ التثبيت...',
            loading: true
        })
        try {
            await axios.post(`estimations/${item.id}/pin/`)
            showMessage({ text: 'تم التثبيت' })
            queryClient.invalidateQueries({ queryKey: ['estimations'] })
        } catch {
            showMessage({ text: 'حدث خطأ' })
        }
    }

    return {
        handleClick,
        handleEdit,
        handleDelete,
        handleExport,
        handlePin,

        anchor,
        setAnchor
    }
}
